import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Settings as SettingsIcon, FolderTree, ChevronRight, FileEdit } from 'lucide-react';

export function SettingsPage() {
  const navigate = useNavigate();

  const settingsCategories = [
    {
      id: 'project-creation-setup',
      title: 'Project Creation Setup',
      description: 'Configure the Project Creation setup',
      icon: FileEdit,
      onClick: () => navigate('/project-creation-setup'),
    },
    {
      id: 'category-management',
      title: 'Budget Category Management',
      description: 'Manage global budget categories and subcategories used across all projects',
      icon: FolderTree,
      onClick: () => navigate('/category-management'),
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Settings</h2>
        <p className="text-muted-foreground">
          Configure your Access Project Management preferences
        </p>
      </div>

      <div className="grid gap-4">
        {settingsCategories.map((category) => {
          const Icon = category.icon;
          return (
            <Card key={category.id} className="hover:shadow-md transition-shadow cursor-pointer" onClick={category.onClick}>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-primary/10">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                      <CardTitle className="text-lg">{category.title}</CardTitle>
                      <CardDescription className="mt-1">{category.description}</CardDescription>
                    </div>
                  </div>
                  <ChevronRight className="h-5 w-5 text-muted-foreground" />
                </div>
              </CardHeader>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <SettingsIcon className="h-5 w-5" />
            Application Settings
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Additional settings configuration coming soon.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
